const envs = {
  prod: {
    APP_ENV: 'prod',
    SERVER_ROOT: 'https://api.sustain.health',
  },
  staging: {
    APP_ENV: 'staging',
    SERVER_ROOT: 'https://api.sustainstaging.com',
  },
  development: {
    APP_ENV: 'dev',
    SERVER_ROOT: 'https://api.sustain-dev.com',
  },
};

const env = import.meta.env.VITE_APP_ENV || 'staging';

const config = {
  ...envs[env as keyof typeof envs],
  ACCEPTED_MEDIA_TYPES: {
    IMAGE_TYPE: ['image/png', 'image/jpeg'],
    TRANSCRIPT_TYPE: ['text/vtt', 'text/plain'],
    VIDEO_TYPE: ['video/mp4', 'video/quicktime', 'video/mov'],
    AUDIO_TYPE: ['audio/mpeg', 'audio/mp3', 'audio/mp4', 'audio/m4a'],
  },
};

export default config;
